import type React from "react";

interface NodeHoverTooltipProps {
	name: string;
	elementType: string;
	metadata: Record<string, unknown>;
	position: { x: number; y: number };
	hint?: string;
}

const NodeHoverTooltip: React.FC<NodeHoverTooltipProps> = ({ name, elementType, metadata, position, hint }) => {
	const metaEntries = Object.entries(metadata).filter(([key]) => key !== "iri");

	return (
		<div
			className="fixed z-50 pointer-events-none max-w-xs rounded-lg border border-subtle surface-alt shadow-lg px-3 py-2 text-sm"
			style={{ left: position.x + 15, top: position.y + 15 }}
		>
			<div className="space-y-1">
				<div className="font-medium text-primary truncate">{name}</div>
				<div className="text-muted text-xs">{elementType}</div>
				{metaEntries.length > 0 && (
					<div className="mt-2 pt-2 border-t border-subtle space-y-0.5">
						{metaEntries.map(([key, value]) => (
							<div key={key} className="flex gap-2 text-xs">
								<span className="text-muted shrink-0">{key}:</span>
								<span className="text-primary truncate">{String(value)}</span>
							</div>
						))}
					</div>
				)}
				{hint && <div className="mt-2 pt-2 border-t border-subtle text-xs text-muted italic">{hint}</div>}
			</div>
		</div>
	);
};

export default NodeHoverTooltip;
